module.exports = __webpack_public_path__ + "img/Key_Forces_and_Trends_that_Could_Dramatically_Change_the_Securities_Services_Landscape.3d50f199.jpg";